<template>
  <div class="h-100">
    <div class="d-flex p-1 pb-2 header align-items-center">
      <div class="flex-grow-1 my-auto text-right">
        <span v-text="records"></span>
      </div>
      <div v-if="ready" class="ml-2 dropdown">
        <button class="btn btn-link text-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-ellipsis-v"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#" @click.prevent="downloadCSV">
            <i class="fas fa-download mr-2"></i>
            Download CSV
          </a>
        </div>
      </div>
    </div>
    <template v-if="ready">
      <scroll-area class="pr-3">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>
                <span>Contract Id</span>
              </th>
              <th>
                <span>Date</span>
              </th>
              <th>
                <span>Item</span>
              </th>
              <th>
                <span>Modified by</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(audit, i) in allAudits" :key="audit._id">
              <td>
                <a v-if="audit.ref"
                  class="badge badge-custom"
                  title="View contract"
                  v-text="audit.id"
                ></a>
                <span v-else></span>
              </td>
              <td>
                <span v-text="audit.date"></span>
              </td>
              <td>
                <span v-text="audit.item"></span>
              </td>
              <td>
                <span v-text="audit.user ? `${audit.user.name} - ${audit.user.email}` : ``"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </scroll-area>
    </template>
    <template v-else>
      <loading></loading>
    </template>
  </div>
</template>

<style scoped>

.dropdown-item {
  color: #212529 !important; 
  font-size: 12px;
}

.header div {
  margin-right: 1em;
  font-size: 0.8rem;
}

span {
  font-size: 0.9em;
}

span.link {
  cursor: pointer;
  text-decoration: underline;
}
</style>

<script>
import moment from "moment";
import { loading, scrollArea } from "../../../../component";
import { Api, Csv, Record, Modal } from "../../../../factory";

export default {
  get components() {
    return {
      scrollArea,
      loading,
    };
  },
  data() {
    return {
      ready: false,
      allAudits: [],
    };
  },
  created() {
    this.init();
  },
  computed: {
    records() {
      const count = this.allAudits.length;
      return `Showing ${count} of ${count} record(s)`;
    }
  },
  methods: {
    async init() {
      await this.getAllAudits();
      this.ready = true;
    },
    async getAllAudits() {
      const audits = (await Api.get(`audits`)).data;
      // Sort by date in descending order (most recent first)
      audits.sort((a, b) => new Date(b.date) - new Date(a.date));
      // const user = (await Api.get("users/"))
      this.allAudits = audits.map(audit => {
        const id = audit.ref ? Record.id({ id: audit.ref }) : ""
        return { ...audit, id, date: moment(audit.date).format(`MM/DD/YYYY`) }
      })
    },
    downloadCSV() {
      const headers = [
        "Contract Id",
        "Date",
        "Item",
        "Modified by",
      ];
      const data = this.allAudits.map((audit) => [
        audit.id || "",
        audit.date,
        audit.item,
        audit.user ? `${audit.user.name} - ${audit.user.email}` : "",
      ]);

      Csv.download("audits.csv", headers, data);
    }
  },
};
</script>
